// @flow strict

export const customTimezones: {[string]: string | Array<string | null>} = {
  CET: 'Europe/Brussels',
  CST6CDT: 'America/Chicago',
  EET: 'Europe/Athens',
  EST: 'America/New_York',
  EST5EDT: 'America/New_York',
  HST: 'Pacific/Honolulu',
  MST: 'America/Phoenix',
  MET: 'Europe/Brussels',
  MST7MDT: 'America/Denver',
  'Pacific/Yap': 'Pacific/Port_Moresby',
  'Europe/Kyiv': ['-120', 'EU', 'EE%sT', null],
};

export const excludedTimezones: Array<string> = [
  'Factory',
  'Pacific/Kanton',
  'Pacific/Enderbury',
];

export const unsupportedTimezones: Array<string> = [
  'CET',
  'CST6CDT',
  'EET',
  'EST',
  'EST5EDT',
  'HST',
  'MST',
  'MET',
  'MST7MDT',
  'Pacific/Yap',
  'Factory',
  'Pacific/Kanton',
  'Pacific/Enderbury',
];
